import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';

export default class ChangeHeaderTitleMessage extends Message {

    public title: string;
    public prefix: string;
    public suffix: string;
    public refTypeName: string;
    public refObjectIdent: string;

    public constructor(params: any) {
        super(params);

        this.title = this.paramOrDefault(params.title, '');
        this.prefix = this.paramOrDefault(params.prefix, '');
        this.suffix = this.paramOrDefault(params.suffix, null);
        this.refTypeName = this.paramOrDefault(params.refTypeName, null);
        this.refObjectIdent = this.paramOrDefault(params.refObjectIdent, null);
    }
}

ComponentManager.setMessage('ChangeHeaderTitleMessage', ChangeHeaderTitleMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');